import { ApplicationState } from '../../state/ducks';
import { Order } from '../../state/models/Order';

export const getOrder = (state: ApplicationState, orderId: number): Order | undefined => state.orders.byId[orderId];
export const isLoadingOrder = (state: ApplicationState, orderId: number): boolean => state.orders.loadingIds.find(x => x === orderId) != null;